<template>
  <div class="avatar">
    <div class="inner">
      <div class="inner2">
        <img
          v-if="image"
          :src="image"
        >
        <div
          v-else
          class="placeholder"
        >
          {{ placeholder }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvatarBorder',
  props: {
    image: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  .inner {
    border-radius: inherit;
    padding-bottom: 100%;
    position: relative;
    width: 100%;

    .inner2 {
      overflow: hidden;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      border-radius: inherit;

      img {
        display: block;
        width: 100%;
        height: 100%;
        -o-object-fit: cover;
        object-fit: cover;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: 0.1s;
      }

      .placeholder {
        background: rgb(96, 70, 129);
        height: 100%;
        width: 100%;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
